<h1 mat-dialog-title>Video del Lote {{ data?.lotCode }}</h1>
<div mat-dialog-content>
    <iframe
        style="width: 100%; height: 25em;"
        [src]="data.videoUrl | videoUrlDecode:true:true"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
    ></iframe>
</div>
